import React, { useContext, useEffect, useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { solarizedlight } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Profile,
  userFetchTeamStixifyProfileDetail,
} from "../../../services/stixify_api.ts";
import { URLS } from "../../../services/urls.ts";
import { TeamRouteContext } from "../../team-layout.tsx/index.tsx";

const TeamStixifyProfileDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>(); // `id` corresponds to `:id` in the route
  const [profile, setProfile] = useState<Profile>();
  const { teamId } = useContext(TeamRouteContext);
  const navigate = useNavigate()

  const loadProfile = async () => {
    if (!id) return;
    try{
        const res = await userFetchTeamStixifyProfileDetail(id);
        setProfile(res.data);
    } catch(err) {
      if(err?.response?.status == 404) {
        return navigate(URLS.notFound())
      }
      throw err
    }
  };
  useEffect(() => {
    loadProfile();
  }, [id]);

  useEffect(() => {
    document.title = `${profile?.name} | Obstracts Web`;
  }, [profile]);

  const getReportsUrls = () => {
    if(teamId) return URLS.teamReports(teamId || "", { profile_id: id })
    return URLS.staffReports({profile_id: id})
  }
  return (
    <Box p={4}>
      <Box>
        <Box sx={{ display: "flex" }}>
          <Typography id="modal-title" variant="h4">
            Profile Details
          </Typography>
          <Link to={getReportsUrls()}>
            <Button sx={{ marginLeft: "3rem" }} variant="contained">
              View Reports
            </Button>
          </Link>
          {!teamId && <Link to={URLS.staffProfileEdit(id || "")}>
            <Button variant="contained" sx={{marginLeft: '1rem'}}>Edit</Button>
          </Link>}
        </Box>
        {profile ? (
          <Box mt={4}>
            <Typography variant="h5">Profile Setup</Typography>
            <SyntaxHighlighter language="json" style={solarizedlight}>
              {JSON.stringify(profile, null, 2)}
            </SyntaxHighlighter>
          </Box>
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Box>
    </Box>
  );
};

export default TeamStixifyProfileDetail;
